module.exports = __webpack_public_path__ + "img/Front-Contour-Reference6@2x.00bb4525.jpg";